<template>
  <div class="home">
    <!-- 顶部导航 -->
    <!-- 主视觉区（Banner+介绍+按钮+多图） -->
    <section class="hero-section">
      <div class="hero-banner">
        <div class="hero-title-group">
          <div class="hero-title">
            {{ $t("home.banner.title1") }}<br />
            {{ $t("home.banner.title2") }}<br />
            {{ $t("home.banner.title3") }}
            
          </div>
          <div class="hero-btns">
            <ConsultButtonDesktop @click="onConsultClick" :text="$t('home.banner.ask')" />
            <!-- <button
              class="evaluate-btn"
              size="medium"
              plain
              @click="scrollToContact"
            >
              {{ $t("home.banner.Evaluation") }}
            </button> -->
          </div>
          <img class="hero-title-underline" :src="require('@/assets/images/yellow.png')" alt="underline" :class="{
            'hero-title-underline-en': $i18n.locale === 'en',
            'hero-title-underline-zh': $i18n.locale === 'zh'
          }" />
        </div>
      </div>
    </section>
    <!-- 主视觉图片+绿色盒子独立模块 -->
    <section class="hero-visual-section">
      <div class="hero-images-wrapper">
        <div class="hero-green-bg"></div>
        <img class="hero-img hero-img-1" :src="require('@/assets/images/banner1.png')" alt="banner1" loading="lazy" />
        <img class="hero-img hero-img-2" :src="require('@/assets/images/banner2.png')" alt="banner2" loading="lazy" />
        <img class="hero-img hero-img-3" :src="require('@/assets/images/banner3.png')" alt="banner3" loading="lazy" />
        <img class="hero-img hero-img-4" :src="require('@/assets/images/banner4.png')" alt="banner4" loading="lazy" />
        <img class="hero-img hero-img-5" :src="require('@/assets/images/banner5.png')" alt="banner5" loading="lazy" />
      </div>
      <div class="info-bar">
        <div class="info-bar-content">
          <div class="info-bar-text">
            <div class="info-bar-text-item1"> {{ $i18n.locale === 'zh' ? '剑桥科博留学' : 'HOPE Guardianship'
              }}</div>
            <div class="info-bar-text-item2">
              <span> {{ $i18n.locale === 'zh' ? '20+' : '20+' }}</span>
              <span style="font-size: 18px;opacity: 0.87;"> {{ $i18n.locale === 'zh' ? '合作名校' : 'Partner Schools in UK'
              }}</span>
            </div>
          </div>
          <div class="info-bar-underline">
            <img :src="require('@/assets/images/yellow.png')" alt="underline" />
          </div>
        </div>
      </div>
      <section class="partners-section">
        <div class="partners-content">
          <div class="partners-logos-row" v-for="(row, rowIdx) in logoRows" :key="rowIdx">
            <div class="logos-slider" :class="rowIdx === 0 ? 'slide-left' : 'slide-right'">
              <div class="partner-logo-box" v-for="(logo, idx) in row.concat(row)" :key="idx">
                <img :src="logo" :alt="`School logo ${rowIdx * 16 + (idx % 16) + 1}`" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>

    <!-- 细心守护功能 -->
    <section class="caring-guardianship-section">
      <div class="caring-container">
        <div class="school-feedback-title-box">
          <div class="school-feedback-title">
            {{ $t("caring.subTitle") }}
          </div>
          <div class="guardian-title" style="white-space: pre-line">
            {{ $t("caring.title") }}
          </div>
          <img class="school-feedback-title-underline" v-lazy="require('@/assets/images/yellow.png')" alt="underline" />
        </div>
        <div class="caring-cards" ref="caringCards">
          <div class="caring-card" v-for="(card, index) in caringCards" :key="index" @click="handleCardClick(index)">
            <div class="card-box" :class="getCardBgClass(index)">
              <div class="card-content" :class="index % 2 === 0 ? 'content-top' : 'content-bottom'">
                <div v-if="index % 2 === 0" class="text-content">
                  <div class="card-title">
                    <template v-if="index === 1">
                      <span class="black-text">专业、可信的</span>
                      <span class="gold-text">学业守护</span>
                    </template>
                    <template v-else-if="index === 2 && $i18n.locale === 'en'">
                      <div style="display: flex; flex-direction: column">
                        <div class="gold-text">{{ "Rapid emergency " }}</div>
                        <div class="black-text">response and swift support services</div>
                      </div>
                    </template>
                    <template v-else>
                      <span class="gold-text">{{
                        getTitleGoldPart(index)
                        }}</span>
                      <span class="black-text">{{
                        getTitleBlackPart(index)
                        }}</span>
                    </template>
                  </div>
                  <div class="card-subtitle" v-if="$t(`home.cardTitles.card${index}.subtitle`)">
                    {{ $t(`home.cardTitles.card${index}.subtitle`) }}
                  </div>
                  <p class="card-description">
                    {{ $t(`home.cardTitles.card${index}.desc`) }}
                  </p>
                  <p class="card-note" v-if="index === 0">
                    {{ $t("home.cardTitles.card0.note") }}
                  </p>
                </div>

                <div class="card-icon" :class="index % 2 === 0 ? 'icon-bottom' : 'icon-top'">
                  <img :src="getCardIcon(index)" alt="icon" class="icon-img" />
                </div>

                <div v-if="index % 2 !== 0" class="text-content">
                  <div class="card-title">
                    <template v-if="index === 1 && $i18n.locale === 'zh'">
                      <span class="black-text">专业、可信的</span>
                      <span class="gold-text">学业守护</span>
                    </template>
                    <template v-else-if="index === 1 && $i18n.locale === 'en'">
                      <div style="display: flex; flex-direction: column">
                        <div class="black-text">Professional and reliable academic support</div>
                        <div class="gold-text">From school selection to course choice</div>
                      </div>
                    </template>

                    <template v-else>
                      <span class="gold-text">{{
                        getTitleGoldPart(index)
                        }}</span>
                      <span class="black-text">{{
                        getTitleBlackPart(index)
                        }}</span>
                    </template>
                  </div>
                  <div class="card-subtitle" v-if="$t(`home.cardTitles.card${index}.subtitle`)"
                    style="white-space: pre-line">
                    {{ $t(`home.cardTitles.card${index}.subtitle`) }}
                  </div>
                  <p class="card-description">
                    {{ $t(`home.cardTitles.card${index}.desc`) }}
                  </p>
                </div>

                <div class="arrow-box" :class="index % 2 === 0 ? 'arrow-bottom' : 'arrow-top'">
                  <img :src="require('@/assets/images/Arrow 2.png')" alt="Arrow" class="arrow-img" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 悉心关照功能 -->
    <section class="meticulous-care-section">
      <div class="overlay-html-content">
        <div class="background-brand-story-card">
          <div class="background-brand-story-label">
            <!-- {{ $t("meticulousCare.label") }} -->
          </div>
          <div class="background-brand-story-title">
            {{ $t("meticulousCare.title") }}
            <img :class="{
              'background-brand-story-underline-zh': $i18n.locale === 'zh',
              'background-brand-story-underline-en': $i18n.locale === 'en'
            }"
              class="background-brand-story-underline" src="@/assets/images/yellow.png" alt="underline" />
          </div>
          <div class="background-brand-story-desc">
            {{ $t("meticulousCare.desc") }}
          </div>
          <button class="background-brand-story-btn" @click="handleMeticulousCareLearnMore">
            {{ $t("meticulousCare.learnMore") }}
          </button>
        </div>
      </div>
    </section>
    <!-- <BackgroundWithOverlay :background-image="meticulousCareBg" :use-html-content="true" container-height="300px"
      overlay-top="460px" overlay-left="80px" overlay-width="715px" overlay-height="436px" overlay-border-radius="40px"
      :enable-hover="true" @learn-more-click="handleMeticulousCareLearnMore" /> -->
    <!-- Who We Are 区块 -->
    <!-- <section class="who-we-are-section">
      <div class="who-we-are-img-box" @click="authentication">
        <img :src="whoWeAreImage" alt="Who we are" />
      </div>
    </section> -->
    <section class="accreditation-section">
      <div class="accreditation-content">
        <div class="accreditation-text">
          <div class="accreditation-label">
            {{ }}
          </div>
          <img class="accreditation-underline" :class="{
            'accreditation-underline-zh': $i18n.locale === 'zh',
            'accreditation-underline-en': $i18n.locale === 'en'
          }" :src="require('@/assets/images/yellow.png')" alt="underline" />
          <div class="accreditation-title">{{ $t("about.company.title") }}</div>
          <div class="accreditation-desc">
            {{ $t("about.company.desc") }}
          </div>
          <button class="accreditation-btn" @click="authentication">
            {{ $t("about.company.button") }}
          </button>
        </div>
        <div class="accreditation-img">
          <img :src="require('@/assets/images/BrandStory/aegis.png')" alt="AEGIS" loading="lazy" />
        </div>
      </div>
    </section>

    <!-- 金牌监护人背景区块 -->
    <section class="guardian-background-section">
      <div class="guardian-title-box">
        <div class="guardian-title">{{ $t("home.godTitle") }}</div>
        <img class="guardian-title-underline" :src="require('@/assets/images/yellow.png')" alt="underline" />
      </div>
      <!-- 表格区块紧跟标题下方 -->
      <div class="guardian-bg-table">
        <div v-if="
          hoveredRowIndex !== null &&
          getGuardianImgByYear(guardianBgRows[hoveredRowIndex].year)
        " class="guardian-hover-img-container" :style="{
          top: mouseY + 'px',
          left: mouseX + 'px',
          maxWidth: '90vw', // 限制最大宽度
          maxHeight: '80vh', // 限制最大高度
        }">
          <img v-lazy="getGuardianImgByYear(guardianBgRows[hoveredRowIndex].year)" class="guardian-hover-img"
            alt="历史图片" />
        </div>
        <!-- desc区域悬停显示文字容器 -->
        <div v-if="hoveredDescRowIndex !== null" class="guardian-hover-text-container" :style="{
          top: descMouseY + 'px',
          left: descMouseX + 'px',
        }">
          <div class="guardian-hover-text">
            {{ guardianBgRows[hoveredDescRowIndex].desc }}
          </div>
        </div>
        <div class="guardian-bg-row" v-for="(row, idx) in guardianBgRows" :key="idx"
          @click="navigateToBrandStory(row.year)"
          :class="{ 'row-hovered': hoveredRowIndex === idx || hoveredDescRowIndex === idx }">
          <div class="guardian-bg-col year">{{ row.year }}</div>
          <div class="guardian-bg-col event">
            <span class="event-text" @mousemove="handleMouseMove(idx, $event)" @mouseenter="handleRowHover(idx)"
              @mouseleave="hoveredRowIndex = null">{{ row.event }}</span>
          </div>
          <div class="guardian-bg-col desc" @mousemove="handleDescMouseMove(idx, $event)"
            @mouseenter="handleDescHover(idx)" @mouseleave="hoveredDescRowIndex = null">{{ row.desc }}</div>
        </div>
      </div>
    </section>
    <!-- 舍监/学校反馈 -->
    <section class="school-feedback-section">
      <div class="school-feedback-container">
        <!-- 标题区域 -->
        <div class="school-feedback-title-box">
          <div class="school-feedback-title">
            {{ $t("home.schoolFeedbackTitle2") }}
          </div>
          <div class="guardian-title" style="white-space: pre-line">
            {{ $t("home.schoolFeedbackTitle") }}
          </div>
          <img class="school-feedback-title-underline" v-lazy="require('@/assets/images/yellow.png')" alt="underline" />
        </div>

        <!-- 轮播内容区域 -->
        <div class="school-feedback-carousel">
          <div class="carousel-container">
            <div class="carousel-slide" v-for="(item, index) in schoolFeedbackData" :key="index"
              :class="{ active: currentSchoolFeedbackIndex === index }">
              <div class="feedback-content">
                <!-- 学校图标 -->
                <div class="school-icon">
                  <img v-lazy="item.icon" :alt="item.school" />
                </div>

                <!-- 评价人信息 -->
                <div class="feedback-author">
                  <div class="author-name">{{ item.author }}</div>
                  <div class="author-title">{{ item.title }}</div>
                </div>

                <!-- 评价内容 -->
                <div class="feedback-quote">
                  <img class="quote-mark quote-mark-left" v-lazy="require('@/assets/images/yinhaoleft.png')"
                    alt="quote mark" />
                  <div class="quote-text">
                    <div class="quote-text-line" v-for="(line, lineIndex) in item.quote" :key="lineIndex">
                      {{ line.line }}
                    </div>
                  </div>
                  <img class="quote-mark quote-mark-right" v-lazy="require('@/assets/images/yinhaoright.png')"
                    alt="quote mark" />
                </div>
              </div>
            </div>
          </div>

          <!-- 轮播指示器 -->
          <div class="carousel-indicators">
            <div class="indicator" v-for="(item, index) in schoolFeedbackData" :key="index"
              :class="{ active: currentSchoolFeedbackIndex === index }" @click="setSchoolFeedbackIndex(index)"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- 客户感言 -->
    <section ref="testimonialsSection" class="customer-testimonials-section">
      <div class="customer-testimonials-container">
        <div class="customer-testimonials-left">
          <template v-if="testimonialStep === 0">
            <div class="customer-testimonials-desc">
              {{ $t("home.customerTestimonialsDesc") }}
            </div>
            <div class="customer-testimonials-title">
              {{ $t("home.customerTestimonialsTitle") }}
            </div>

            <img class="customer-testimonials-underline" v-lazy="require('@/assets/images/yellow.png')" alt="underline"
              :class="{
                'customer-testimonials-underline-zh': $i18n.locale === 'zh',
                'customer-testimonials-underline-en': $i18n.locale === 'en'
              }" />
          </template>
          <template v-else>
            <!-- 头像和用户信息 -->
            <div class="testimonial-meta">
              <img class="avatar" v-lazy="require('@/assets/images/Testimonials/touxiang.png')" alt="avatar" />
              <div class="meta-info">
                <div class="meta-name">
                  {{ testimonials[testimonialStep - 1].user }}
                </div>
                <div class="meta-school" style="white-space: pre-line">
                  {{ testimonials[testimonialStep - 1].school || "家长" }}
                </div>
              </div>
            </div>
            <!-- 感言内容 -->
            <div class="testimonial-quote">
              <div class="yinhao">
                <img v-lazy="require('@/assets/images/Testimonials/yinhao.png')" alt="yinhao" />
              </div>
              <i class="el-icon-quote-left"></i>
              <p class="testimonial-text" ref="testimonialText" style="white-space: pre-line"
                v-html="testimonials[testimonialStep - 1].desc"></p>
            </div>
          </template>
        </div>
        <div class="customer-testimonials-right">
          <img class="customer-testimonials-img" :src="testimonials[
            Math.min(
              Math.max(testimonialStep, 1) - 1,
              testimonials.length - 1
            )
          ].img
            " alt="testimonial" loading="lazy" />
        </div>
      </div>
      <div class="testimonial-bottom-bar">
        <div class="testimonial-desc">
        </div>
        <button class="testimonial-learn-btn" @click="goToTestimonials">
          {{ $t("home.customerTestimonialsLearnMore") }}
        </button>
      </div>
    </section>
    <!-- 客户感言下方描述和按钮 -->

    <!-- 家长可能关心的事区块 -->
    <section class="parent-faq-section">
      <div class="parent-faq-container">
        <!-- 左侧 -->
        <div class="parent-faq-left">
          <div class="parent-faq-subtitle">
            {{ $t("home.whoWeAre.containerDesc") }}
          </div>
          <div class="parent-faq-title">
            {{ $t("home.whoWeAre.containerTitle") }}
          </div>
          <img class="parent-faq-underline" v-lazy="require('@/assets/images/yellow.png')" alt="underline" />
          <!-- <button class="parent-faq-btn" @click="handleParentFaqBtn">
            {{ $t("home.whoWeAre.containerBtn") }}
          </button> -->
        </div>
        <!-- 右侧 -->
        <div class="parent-faq-right">
          <div class="parent-faq-list">
            <div class="parent-faq-item" v-for="(item, idx) in parentFaqList" :key="idx">
              <div class="parent-faq-qrow" @click="toggleFaq(idx)">
                <span class="parent-faq-number">{{ item.number }}</span>
                <span class="parent-faq-question">{{ item.question }}</span>
                <span class="parent-faq-toggle">{{
                  activeFaq === idx ? "×" : "+"
                  }}</span>
              </div>
              <div class="parent-faq-answer" v-if="activeFaq === idx && item.answer">
                {{ item.answer }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 表单区块 -->
    <section class="practice-section">
      <div class="practice-section-inner">
        <!-- 左侧信息 -->
        <div class="practice-section-left">
          <div class="practice-section-title">
            {{ $t("practice.title1") }}<br />{{ $t("practice.title2") }}<br />{{ $t("practice.title22") }}
          </div>
          <div class="practice-section-desc">
            {{ $t("practice.title3") }}<br />
            <span class="practice-section-check">✓</span>
            {{ $t("practice.title4") }}<br />
            <span class="practice-section-check">✓</span>
            {{ $t("practice.title5") }}<br />
            <span class="practice-section-check">✓</span>
            {{ $t("practice.title6") }}<br />
            <span class="practice-section-desc-sub">{{
              $t("practice.title7")
              }}</span>
          </div>
        </div>
        <!-- 右侧二维码及联系方式 -->
        <div class="practice-section-right">
          <div class="qr-contact-box">
            <img class="qr-img" src="@/assets/images/QR.png" alt="WeChat QR" />
            <div class="qr-tip">{{ $t("practice.wechatContent") }}</div>
            <div class="contact-info-row">
              <div class="contact-info-item">
                <div class="contact-info-label">
                  {{ $t("footer.contact.wechat") }}
                </div>
                <div class="contact-info-value">clarewang23</div>
              </div>
              <div class="contact-info-item">
                <div class="contact-info-label">
                  {{ $t("footer.contact.email") }}
                </div>
                <div class="contact-info-value">clarewang@btinternet.com</div>
              </div>
              <div class="contact-info-item">
                <div class="contact-info-label">
                  {{ $t("footer.contact.phone") }}
                </div>
                <div class="contact-info-value">+44 (0) 7887 505508</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 博客区块 -->
    <section class="blog-section">
      <div class="blog-header">
        <div class="blog-title">{{ $t("blog") }}</div>
        <el-button class="blog-more-btn" type="text" @click="goToBlogList">{{
          $t("more")
          }}</el-button>
      </div>
      <div class="blog-list">
        <router-link v-for="(item, idx) in blogList.slice(0, blogDisplayCount)" :key="idx" class="blog-card"
          :to="`/blog/${item.id}`">
          <div class="blog-img-box">
            <img :src="item.img" :alt="item.title" loading="lazy" />
          </div>
          <div class="blog-date">{{ item.date }}</div>
          <div class="blog-title-text">{{ item.title }}</div>
          <span class="blog-link">{{ $t("readMore") }} <span>→</span></span>
        </router-link>
      </div>
    </section>
    <!-- 底部联系方式和页脚 -->
  </div>
</template>

<script>
// 异步加载组件
// const BackgroundWithOverlay = () =>
//   import("@/components/BackgroundWithOverlay.vue");
import guardianHistory from "@/data/guardianHistory.js";

export default {
  name: "Home",
  components: {
    // BackgroundWithOverlay,
  },

  mounted() {
    const caringCards = this.$refs.caringCards;
    if (caringCards) {
      caringCards.addEventListener("wheel", this.handleCardsWheel, {
        passive: false,
      });
    }
    if (this.$refs.testimonialsSection) {
      this.$refs.testimonialsSection.addEventListener(
        "wheel",
        this.handleTestimonialsWheel,
        { passive: false }
      );
    }
    // 添加窗口大小变化监听器
    window.addEventListener("resize", this.handleResize);
    console.log(this.screenWidth, '---------------------');
    // 启动自动滚动
    this.startAutoScroll();
    // 启动学校反馈轮播
    // this.startSchoolFeedbackCarousel();
  },
  beforeDestroy() {
    const caringCards = this.$refs.caringCards;
    if (caringCards) {
      caringCards.removeEventListener("wheel", this.handleCardsWheel);
    }
    if (this.$refs.testimonialsSection) {
      this.$refs.testimonialsSection.removeEventListener(
        "wheel",
        this.handleTestimonialsWheel
      );
    }
    // 移除窗口大小变化监听器
    window.removeEventListener("resize", this.handleResize);
    // 清理滚动定时器
    clearInterval(this.scrollTimer);
    // 清理学校反馈轮播定时器
    clearInterval(this.schoolFeedbackTimer);
  },
  computed: {
    // 当前语言（用于调试）
    currentLocale() {
      return this.$i18n.locale;
    },
    // 客户感言数据
    testimonials() {
      const testimonialsList = this.$t("home.customerTestimonialsList");
      console.log("客户感言数量:", testimonialsList.length);
      return testimonialsList;
    },

    // 根据当前语言返回对应的卡片数据
    caringCards() {
      const locale = this.$i18n.locale;
      const isZh = locale === "zh";

      const cards = [];
      for (let i = 0; i < 4; i++) {
        try {
          cards.push({
            image: require(`@/assets/images/Card(${i})-${isZh ? "ch" : "en"
              }.png`),
            title: this.$t(`home.cardTitles.card${i}.title`),
          });
        } catch (e) {
          // 如果图片不存在，使用默认图片
          cards.push({
            image: require("@/assets/images/logo.png"),
            title: this.$t(`home.cardTitles.card${i}.title`),
          });
        }
      }

      return cards;
    },
    // 悉心关照背景图片
    meticulousCareBg() {
      try {
        return require("@/assets/images/xixinguanzhao-bg.png");
      } catch (e) {
        return require("@/assets/images/logo.png");
      }
    },

    whoWeAreImage() {
      const locale = this.$i18n.locale;
      try {
        return require(`@/assets/images/Whoweare-${locale === "zh" ? "ch" : "en"
          }.png`);
      } catch (e) {
        return require("@/assets/images/logo.png");
      }
    },
    parentFaqContactImg() {
      const locale = this.$i18n.locale;
      try {
        return require(`@/assets/images/parent-faq-contact-${locale === "zh" ? "ch" : "en"
          }.png`);
      } catch (e) {
        return require("@/assets/images/logo.png");
      }
    },
    parentFaqTitleImg() {
      const locale = this.$i18n.locale;
      try {
        return require(`@/assets/images/${locale === "zh" ? "Aboutshero" : "FaqHeading"
          }.png`);
      } catch (e) {
        return require("@/assets/images/logo.png");
      }
    },
    blogList() {
      // 假设原始数据没有id，这里加工加上id，并过滤掉id为3的博客
      const list = this.$t("blogList");
      const result = list.map((item, idx) => ({ ...item, id: idx + 1 }))
        .filter(item => item.id !== 3); // 过滤掉id为3的博客
      console.log('blogList长度:', result.length);
      return result;
    },
    // 根据屏幕宽度返回blog显示数量
    blogDisplayCount() {
      console.log('blogDisplayCount计算中，screenWidth:', this.screenWidth);
      if ((this.screenWidth > 1750 && this.screenWidth <= 1920) || (this.screenWidth > 1920 && this.screenWidth <= 2560)) {
        console.log('返回4个blog');
        return 4;
      } else {
        console.log('返回3个blog');
        return 3;
      }
    },
    guardianBgRows() {
      return this.$t("guardianBgRows");
    },
    parentFaqList() {
      return this.$t("parents.faq.list");
    },
    // 学校反馈数据
    schoolFeedbackData() {
      return this.$t("home.schoolFeedback");
    },


    logoRows() {
      // 生成32个logo路径
      const logos = [];
      for (let i = 0; i < 32; i++) {
        logos.push(require(`@/assets/images/school/School(${i}).png`));
      }
      // 分成2行，每行16个
      return [logos.slice(0, 16), logos.slice(16, 32)];
    },
  },
  data() {
    return {
      screenWidth: window.innerWidth,
      form: {
        name: "",
        email: "",
        age: "",
        message: "",
      },
      testimonialStep: 0,
      leftIndex: 0,
      imgIndex: 0,
      activeFaq: 0,
      scrollTimer: null,
      scrollStep: 1,
      scrollInterval: 40,
      scrollIntervals: [], // 新增：用于存储logo滚动定时器
      hoveredRowIndex: null, // 记录悬停的表格行index
      mouseX: 0, // 鼠标X坐标
      mouseY: 0, // 鼠标Y坐标
      currentSchoolFeedbackIndex: 0,
      schoolFeedbackTimer: null, // 学校反馈轮播定时器
      hoveredDescRowIndex: null, // 记录desc区域悬停的表格行index
      descMouseX: 0, // desc区域鼠标X坐标
      descMouseY: 0, // desc区域鼠标Y坐标
    };
  },
  methods: {
    // 处理窗口大小变化
    handleResize() {
      this.screenWidth = window.innerWidth;
      console.log('窗口大小变化，新的screenWidth:', this.screenWidth);
    },
    handleCardClick(index) {
      console.log(index);
      this.$router.push("/services");
    },
    authentication() {
      //跳转到https://aegisuk.net/organisations/?college=Guardianship&org_type=gold-standard
      window.open(
        "https://aegisuk.net/organisations/?college=Guardianship&org_type=gold-standard",
        "_blank"
      );
    },
    onConsultClick() {
      this.$router.push("/Practice");
      // TODO: 这里可以实现弹窗、跳转等逻辑
      console.log("立即咨询按钮被点击");
    },
    goToBlogList() {
      this.$router.push("/blog");
    },
    handleCardsWheel(e) {
      const el = this.$refs.caringCards;
      if (!el) return;

      // 判断是否有横向滚动条
      if (el.scrollWidth > el.clientWidth) {
        const atLeft = el.scrollLeft === 0;
        const atRight = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1; // 容差1像素

        if (
          (e.deltaY < 0 && atLeft) || // 向上滚，且已到最左
          (e.deltaY > 0 && atRight) // 向下滚，且已到最右
        ) {
          // 到边界了，不阻止默认，让页面继续滚动
          return;
        } else {
          // 没到边界，阻止默认，只横滑
          e.preventDefault();
          el.scrollLeft += e.deltaY;
        }
      }
    },
    handleTestimonialsWheel(e) {
      // 获取testimonials的实际长度
      const testimonialsLength = this.testimonials
        ? this.testimonials.length
        : 0;

      if (e.deltaY > 0) {
        // 向下滚
        if (this.testimonialStep < testimonialsLength) {
          e.preventDefault();
          this.testimonialStep++;
          this.$nextTick(() => {
            const el = this.$refs.testimonialText;
            if (el) el.scrollTop = 0;
          });
        } else {
          // 已到最后一条，允许页面向下滚动
          return;
        }
      } else if (e.deltaY < 0) {
        // 向上滚
        if (this.testimonialStep > 0) {
          e.preventDefault();
          this.testimonialStep--;
          this.$nextTick(() => {
            const el = this.$refs.testimonialText;
            if (el) el.scrollTop = 0;
          });
        } else {
          // 已到第一条，允许页面向上滚动
          return;
        }
      }
    },
    // 已移除自动滚动功能
    startAutoScroll() {
      // 不再需要
    },
    pauseScroll() {
      // 不再需要
    },
    resumeScroll() {
      // 不再需要
    },

    getCardIcon(index) {
      // 使用提供的图标，按照正确的顺序
      const icons = {
        0: require("@/assets/images/Icon1.png"), // AEGIS金牌监护人图标
        1: require("@/assets/images/Icon2.png"), // 学业图标
        2: require("@/assets/images/Icon3.png"), // 紧急响应图标
        3: require("@/assets/images/Icon4.png"), // 家的温暖图标
        4: require("@/assets/images/Icon5.png"), // 成长理财课图标
      };
      return icons[index] || require("@/assets/images/Icon1.png");
    },
    getTitleGoldPart(index) {
      const locale = this.$i18n.locale;
      const isZh = locale === "zh";

      // 根据不同卡片的索引返回黄色部分
      if (isZh) {
        switch (index) {
          case 0:
            return "AEGIS";
          case 1:
            return "学业守护";
          case 2:
            return "紧急响应";
          case 3:
            return "家的温暖";
          case 4:
            return "成长理财课";
          default:
            return "";
        }
      } else {
        switch (index) {
          case 0:
            return "AEGIS Gold Standard";
          case 1:
            return "";
          case 2:
            return "<2-Hour";
          case 3:
            return "A warm home";
          case 4:
            return "Financial";
          default:
            return "";
        }
      }
    },
    getTitleBlackPart(index) {
      const locale = this.$i18n.locale;
      const isZh = locale === "zh";

      // 根据不同卡片的索引返回黑色部分
      if (isZh) {
        switch (index) {
          case 0:
            return "金牌认证";
          case 1:
            return "专业可信的";
          case 2:
            return "";
          case 3:
            return "";
          case 4:
            return "";
          default:
            return "";
        }
      } else {
        switch (index) {
          case 0:
            return "";
          case 1:
            return "";
          case 2:
            return "Emergency Response";
          case 3:
            return "";
          case 4:
            return "";
          default:
            return "";
        }
      }
    },
    getCardBgClass(index) {
      // 根据卡片索引返回不同的背景图片类名
      return index % 2 === 0 ? "bg-down" : "bg-up";
    },
    toggleFaq(idx) {
      this.activeFaq = this.activeFaq === idx ? -1 : idx;
    },
    handleParentFaqBtn() {
      this.$router.push("/Practice");
    },
    scrollToContact() {
      this.$router.push("/Practice");
      // const el = this.$refs.contactSection;
      // if (el && el.scrollIntoView) {
      //   el.scrollIntoView({ behavior: "smooth", block: "start" });
      //   // 添加偏移量以确保完全可见
      //   // 延迟时间根据滚动动画时间调整
      // }
    },
    goToTestimonials() {
      this.$router.push("/testimonials");
    },
    getGuardianImgByYear(year) {
      const found = guardianHistory.find((item) => item.year == year);
      return found ? require(`@/assets/images/BrandStory/${found.img}`) : null;
    },
    handleRowHover(idx) {
      this.hoveredRowIndex = idx;
    },
    handleMouseMove(idx, event) {
      // 更新当前鼠标位置
      this.mouseX = event.clientX;
      this.mouseY = event.clientY;

      // 确保当前悬停的行索引正确
      if (this.hoveredRowIndex !== idx) {
        this.hoveredRowIndex = idx;
      }

      // 防止图片超出视口右侧边界
      const viewportWidth = window.innerWidth;
      const imageWidth = 616; // 图片宽度
      const margin = 20; // 右侧边距

      if (this.mouseX + imageWidth + margin > viewportWidth) {
        // 如果图片会超出右侧边界，则将其显示在鼠标左侧
        this.mouseX = this.mouseX - imageWidth - margin;
      }
    },
    handleDescHover(idx) {
      this.hoveredDescRowIndex = idx;
    },
    handleDescMouseMove(idx, event) {
      // 更新desc区域鼠标位置
      this.descMouseX = event.clientX;
      this.descMouseY = event.clientY;

      // 确保当前悬停的行索引正确
      if (this.hoveredDescRowIndex !== idx) {
        this.hoveredDescRowIndex = idx;
      }

      // 防止文字框超出视口右侧边界
      const viewportWidth = window.innerWidth;
      const textBoxWidth = 300; // 文字框宽度
      const margin = 20; // 右侧边距

      if (this.descMouseX + textBoxWidth + margin > viewportWidth) {
        // 如果文字框会超出右侧边界，则将其显示在鼠标左侧
        this.descMouseX = this.descMouseX - textBoxWidth - margin;
      }
    },
    navigateToBrandStory(year) {
      // 跳转到品牌故事页面，并传递年份参数
      this.$router.push({
        path: "/about",
        query: { year: year },
      });
    },
    handleMeticulousCareLearnMore() {
      // 处理悉心关照"了解更多"按钮点击事件
      console.log("悉心关照了解更多按钮被点击");
      // 这里可以添加跳转逻辑，比如跳转到关于页面或其他相关页面
      this.$router.push("/about");
    },
    setSchoolFeedbackIndex(index) {
      this.currentSchoolFeedbackIndex = index;
    },
    startSchoolFeedbackCarousel() {
      this.schoolFeedbackTimer = setInterval(() => {
        this.currentSchoolFeedbackIndex =
          (this.currentSchoolFeedbackIndex + 1) %
          this.schoolFeedbackData.length;
      }, 4000); // 每4秒切换一次
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
}

.meticulous-care-section {
  max-width: 1920px;
  margin: 0 auto;
  padding: 0;
  position: relative;
  z-index: 1;
  padding: 0 80px;
  display: flex;
  justify-content: center;

  /* HTML内容样式 */
  .overlay-html-content {
    width: 715px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border-radius: 40px;
  }

  .background-brand-story-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 40px;
    max-width: 715px;
    width: 715px;
    /* 固定宽度 */
    box-sizing: border-box;
    height: auto;
    position: relative;
    gap: 40px;
  }

  .background-brand-story-label {
    font-family: "Alibaba PuHuiTi";
    font-weight: 500;
    font-size: 18px;
    color: #000000;
    margin-bottom: 16px;
    opacity: 0.87;
  }

  .background-brand-story-title {
    font-family: "Alibaba PuHuiTi";
    font-weight: 600;
    font-size: 48px;
    line-height: 56px;
    color: #282938;
    position: relative;
    white-space: pre-line;
    /* 最小高度，2行文本 = 56px * 2 */
    height: auto;
    /* 自动调整高度 */
  }

  .background-brand-story-underline {
    position: absolute;
    width: 204px;
    /* 固定宽度：715px(卡片宽度) - 80px(左右内边距) */
    height: 18px;
    border-radius: 10px;
    z-index: 0;
    pointer-events: none;
    user-select: none;
    bottom: 30px;
    /* 相对于文本底部定位，适应不同语言 */
  }

  .background-brand-story-underline-zh {
    top: 90%;
    left: 40%;
  }

  .background-brand-story-underline-en {
    top: 90%;
    left: 30%;
  }

  .background-brand-story-desc {
    font-family: "Alibaba PuHuiTi";
    font-weight: 400;
    font-size: 24px;
    line-height: 1.6;
    color: #666;
    white-space: pre-line;
    text-align: center;
  }

  .background-brand-story-btn {
    height: 40px;
    width: 112px;
    background: transparent;
    border: 2px solid #282938;
    color: #282938;
    border-radius: 100px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: "Alibaba PuHuiTi";
  }

  .background-brand-story-btn:hover {
    background: #282938;
    color: #fff;
  }
}

.hero-section {
  width: 582px;
  height: 310px;
  margin: 0 auto 240px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  box-sizing: border-box;
}

.hero-banner {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.hero-title-group {
  position: relative;
  text-align: center;
  .hero-title-underline {
  position: absolute;
  width: 159.97px;
  height: 17.72px;
  border-radius: 10px;
  z-index: 0;
  pointer-events: none;
  user-select: none;
}

.hero-title-underline-en {
  right: 500px;
  top: 60px;
}

.hero-title-underline-zh {
  right: 430px;
  top: 62px;
}
}

.hero-title {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-weight: 600;
  font-size: 54px;
  line-height: 74px;
  color: #282938;
  margin-bottom: 32px;
  width: 1000px;
  height: 222px;

  
}

.year-highlight {
  font-weight: 700;
  position: relative;
  color: #282938;
}

.year-highlight::after {
  content: "";
  display: block;
  width: 100%;
  height: 8px;
  background: #ffe066;
  position: absolute;
  left: 0;
  bottom: 8px;
  z-index: -1;
  border-radius: 4px;
}

.hero-btns {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.hero-consult-btn {
  width: 300px;
  // min-width: 162px;
  height: 48px;
  border-radius: 100px;
  background: #ffd24d;
  color: #282938;
  font-size: 18px;
  font-weight: 600;
  border: none;
  box-shadow: none;
  padding: 0 50px 0 24px;
  white-space: nowrap;
}

.hero-consult-btn:hover {
  background: #ffe066;
}

.evaluate-btn {
  min-width: 130px;
  padding: 0 24px;
  height: 48px;
  border-radius: 100px;
  border: 2px solid #282938;
  color: #282938;
  font-size: 18px;
  font-weight: 600;
  background: #fff;
  white-space: nowrap;
  box-sizing: border-box;
}

.evaluate-btn:hover {
  background: #ffe066;
}

.hero-visual-section {
  position: relative;
  width: 100%;
  height: 750px;
  margin: 0 auto;
  overflow: visible;
  z-index: 1;
  padding-top: 60px; // 新增
}

.hero-images-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: 340px;
  position: relative;
  z-index: 2;
  gap: 16px;
  margin-top: -190px; // 让图片顶部超出父级
  overflow: visible;
}

.hero-green-bg {
  position: absolute;
  left: 0;
  top: 180px;
  width: 100%;
  height: 700px;
  background: #267e75;
  z-index: 1;
  pointer-events: none;
  transform: rotate(180deg);
}

.hero-img {
  object-fit: cover;
  border-radius: 16px;
  background: transparent;
  pointer-events: none;
  z-index: 9;
  margin-bottom: -40px;
  box-shadow: none;
  transition: none;
}

.hero-img-1 {
  width: 298px;
  height: 207px;
  z-index: 1;
  margin-top: 10px;
}

.hero-img-2 {
  width: 310px;
  height: 389px;
  margin-left: -70px;
  z-index: 2;
  margin-top: -34px;
}

.hero-img-3 {
  width: 262px;
  height: 355px;
  margin-left: -60px;
  z-index: 3;
  margin-top: -34px;
}

.hero-img-4 {
  width: 250px;
  height: 336px;
  margin-left: -44px;
  z-index: 2;
  margin-top: -39px;
}

.hero-img-5 {
  width: 327px;
  height: 226px;
  margin-left: -42px;
  z-index: 1;
  margin-top: 21px;
}

.partners-section {
  position: absolute;
  left: 50%;
  bottom: 30px;
  transform: translateX(-50%);
  width: 1200px;
  padding: 40px 32px 32px 32px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.partners-title {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 24px;
}

.partners-title span {
  color: #ffd24d;
  font-size: 24px;
  margin-left: 8px;
}

.partners-logos-row {
  overflow: hidden;
  width: 100%;
  margin-bottom: 24px;
  position: relative;
}

.logos-slider {
  display: flex;
  align-items: center;
  gap: 24px;
  width: max-content;
}

.slide-left {
  animation: slideLeft 60s linear infinite;
}

.slide-right {
  animation: slideRight 60s linear infinite;
}

@keyframes slideLeft {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

@keyframes slideRight {
  0% {
    transform: translateX(-50%);
  }

  100% {
    transform: translateX(0);
  }
}

.partner-logo-box {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  height: 90px;
  min-height: 90px;
  max-width: 400px;
  min-width: 220px;
  box-sizing: border-box;
  flex: 0 0 auto;
  overflow: hidden;
}

.partner-logo-box img {
  height: 90px;
  width: auto;

  // object-fit: none;
  display: block;
  margin: 0 auto;
}

.logo-placeholder {
  width: 48px;
  height: 48px;
  background: #f5f5f5;
  border-radius: 8px;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #bbb;
}

.school-name {
  font-size: 18px;
  color: #333;
  font-weight: 500;
}

.info-bar {
  position: absolute;
  top: 305px;
  height: 85px;
  z-index: 20;
  margin-left: 80px;
}

.info-bar-content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.info-bar-text {
  font-size: 16px;
  font-weight: 600;
  color: #282938;
  line-height: 1.4;
  margin-bottom: 8px;
  display: flex;
  font-size: 48px;
  line-height: 64px;
  color: #fff;
  height: 64px;

  .info-bar-text-item1 {
    font-size: 48px;
    line-height: 64px;
    color: #fff;
    margin-right: 24px;
  }

  .info-bar-text-item2 {
    padding-left: 26px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: 85px;
    border-left: 1px solid #CED1D9;
    line-height: 40px;
  }
}

.info-bar-underline {
  position: absolute;
  width: 197px;
  height: 7px;
  bottom: 10px;
  left: 7px;
  img{
    width: 100%;
    height: 100%;
  }
}



.info-bar-underline img:hover {
  opacity: 1;
  transform: scaleY(1.1);
  filter: brightness(1.2) saturate(1.2);
}

.info-count-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  background: #267e75;
  border: 2px solid #36c4b7;
  border-radius: 12px;
  min-width: 110px;
  height: 64px;
  padding: 8px 24px 8px 24px;
  box-sizing: border-box;
}

.info-count {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  line-height: 1;
}

.info-label {
  font-size: 16px;
  color: #fff;
  margin-top: 2px;
  line-height: 1;
}

.school-slider {
  display: flex;
  align-items: center;
  gap: 24px;
  white-space: nowrap;
  overflow: hidden;
}

.school-slider img {
  height: 90px;
  object-fit: contain;
  flex-shrink: 0;
  border-radius: 8px;
  padding: 8px;
  box-sizing: border-box;
}

.school-slider img.wide {
  width: 334px;
}

.school-slider img.narrow {
  width: 266px;
}

.school-slider-right {
  animation: slideRight 60s linear infinite;
}

.school-slider-left {
  animation: slideLeft 60s linear infinite;
}

@keyframes slideRight {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

@keyframes slideLeft {
  0% {
    transform: translateX(-50%);
  }

  100% {
    transform: translateX(0);
  }
}

/* 细心守护功能样式 */
.caring-guardianship-section {
  padding: 80px 0;
  position: relative;
  min-height: 600px;
}

.caring-guardianship-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* 移除有问题的SVG背景，避免Safari渲染问题 */
  background: transparent;
  pointer-events: none;

  /* Safari特殊处理 - 确保背景透明 */
  @supports (-webkit-appearance: none) {
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;
  }
}

.caring-container {
  max-width: 100%;
  padding: 0;
  position: relative;
  z-index: 1;
  padding: 0 80px;
}

.caring-title {
  text-align: left;
  width: 639px;
  height: 100px;
  margin-bottom: 53px;
}

.caring-title-text {
  position: relative;
  display: inline-block;
}

.title-text {
  font-family: 'Alibaba PuHuiTi', sans-serif;
  font-size: 48px;
  font-weight: 600;
  color: #282938;
  line-height: 1.2;
  display: block;
  margin-bottom: 8px;
}



.caring-cards {
  display: flex;
  gap: 32px;
  overflow-x: auto;
  padding: 40px 0;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
  margin: 0 auto;
  max-width: 100%;
  align-items: flex-start;
}

.caring-cards::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari and Opera */
}

.caring-card {
  width: 550px;
  height: 520px;
  background: none;
  border-radius: 16px;
  position: relative;
  flex-shrink: 0;
  transition: all 0.3s ease;
  cursor: pointer;
  overflow: visible;
}

.caring-card:hover {
  transform: translateY(-8px);
}

.card-box {
  width: 100%;
  height: 100%;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 40px;
  padding-left: 39px;
  padding-right: 39px;
  box-sizing: border-box;
  transition: transform 0.3s ease;
  position: relative;
  overflow: hidden;
}

.bg-down {
  background-image: url("~@/assets/images/down.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-up {
  background-image: url("~@/assets/images/up.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.caring-card:hover .card-box {
  transform: scale(1.02);
}

.card-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

.content-top .text-content {
  margin-bottom: auto;
  padding-bottom: 100px;
}

.content-bottom .text-content {
  margin-top: auto;
  padding-top: 100px;
}

.text-content {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.card-title {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-size: 38px;
  font-weight: 600;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  line-height: 1.3;
  width: 450px;
}

.gold-text {
  color: #e5ae21;
  font-weight: 600;
  margin-right: 5px;
}

.black-text {
  color: #282938;
}

.card-subtitle {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-size: 38px;
  font-weight: 600;
  color: #282938;
  margin-bottom: 15px;
  width: 450px;
}

.card-description {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-size: 16px;
  line-height: 28px;
  color: #282938;
  flex-grow: 0;
  opacity: 0.7;
}

.card-note {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-size: 14px;
  color: #888;
  margin-top: 10px;
  margin-bottom: 0;
  line-height: 28px;
  opacity: 0.4;
}

.card-icon {
  display: flex;
  justify-content: flex-start;
  position: absolute;
}

.icon-bottom {
  bottom: 0;
  left: 0%;
}

.icon-top {
  top: 0;
  left: 0;
}

.icon-img {
  width: 100px;
  height: 100px;
  object-fit: contain;
  filter: brightness(1.05);
  opacity: 0.9;
}

.arrow-box {
  width: 100px;
  height: 100px;
  background-color: #f4f6fc;
  border-radius: 16px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}

.arrow-bottom {
  bottom: -10%;
  right: -10%;
}

.arrow-top {
  top: -10%;
  right: -10%;
}

.arrow-img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.accreditation-section {
  min-height: 408px;
  background: #fcd980;
  border-radius: 40px;
  padding: 60px 0px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  margin-top: 80px;
  margin-left: 80px;
  margin-right: 80px;
}

.accreditation-content {
  padding: 0 80px;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
}

.accreditation-text {
  position: relative;
  flex: 1;
  padding-right: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.accreditation-label {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 18px;
  color: #282938;
}

.accreditation-underline {
  position: absolute;
  width: 159.97px;
  height: 17.72px;
}

.accreditation-underline-zh {
  left: 59px;
  top: 70px;
}

.accreditation-underline-en {
  left: 224px;
  top: 64px;
}

.accreditation-title {
  font-size: 38px;
  font-weight: 600;
  margin-bottom: 24px;
  color: #282938;
}

.accreditation-desc {
  width: 700px;
  font-size: 16px;
  color: #282938;
  margin-bottom: 32px;
  line-height: 28px;
  max-width: 750px;
  opacity: 0.7;
}

.accreditation-btn {
  width: fit-content;
  height: 40px;
  line-height: 35px;
  padding: 0px 32px;
  font-size: 16px;
  color: #282938;
  border: 2px solid #282938;
  border-radius: 30px;
  background: transparent;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;

  &:hover {
    background: #282938;
    color: #fff;
  }
}

.accreditation-img {
  display: flex;
  align-items: flex-end;
  height: 219px;
  min-width: 344.88px;

  img {
    width: 344.88px;
    height: 219px;
    border-radius: 40px 40px 0 0;
    object-fit: contain;
    display: block;
  }
}

// 响应式样式
@media (max-width: 1200px) {
  .accreditation-section {
    margin-left: 40px;
    margin-right: 40px;
    padding: 40px 0px;
  }

  .accreditation-content {
    padding: 0 40px;
  }

  .accreditation-text {
    padding-right: 20px;
  }

  .accreditation-desc {
    width: 100%;
    max-width: 600px;
  }
}

@media (max-width: 768px) {
  .accreditation-section {
    margin-left: 20px;
    margin-right: 20px;
    padding: 30px 0px;
    min-height: auto;
    max-height: none;
  }

  .accreditation-content {
    padding: 0 20px;
    flex-direction: column;
    gap: 30px;
  }

  .accreditation-text {
    padding-right: 0;
    padding-bottom: 20px;
  }

  .accreditation-title {
    font-size: 28px;
    margin-bottom: 20px;
  }

  .accreditation-desc {
    width: 100%;
    max-width: 100%;
    margin-bottom: 24px;
  }

  .accreditation-img {
    height: auto;
    min-width: auto;
    justify-content: center;

    img {
      width: 280px;
      height: auto;
      max-height: 180px;
    }
  }
}

@media (max-width: 480px) {
  .accreditation-section {
    margin-left: 15px;
    margin-right: 15px;
    padding: 25px 0px;
  }

  .accreditation-content {
    padding: 0 15px;
  }

  .accreditation-title {
    font-size: 24px;
  }

  .accreditation-desc {
    font-size: 14px;
    line-height: 24px;
  }

  .accreditation-img img {
    width: 240px;
  }
}

.who-we-are-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 80px;
}

.who-we-are-img-box {
  width: 1440px;
  height: 800px;
  border-radius: 40px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.who-we-are-img-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.guardian-background-section {
  width: 100%;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center; // 让子元素居中
  padding: 0 80px;
}

.guardian-title-box {
  position: relative;
  width: 100%;
  margin: 0 auto 40px auto;
  text-align: left;

  .guardian-title-underline {
    position: absolute;
    left: 0;
    bottom: -19px;
    width: 159.97px;
    height: 17.72px;
  }
}

.guardian-title {
  display: inline-block;
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-weight: 700;
  font-size: 38px;
  line-height: 48px;
  color: #282938;
  position: relative;
  z-index: 1;
}

.features-section {
  padding: 100px 0;
  position: relative;
}

.features-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.features-list {
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 80px;
  display: flex;
  justify-content: space-around;
  gap: 32px;
  flex-wrap: wrap;
}

.feature-card {
  width: 300px;
  height: 200px;
  background: #fff;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
  cursor: pointer;
  overflow: hidden;
}

.feature-card:hover {
  transform: translateY(-10px);
}

.feature-title {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-weight: 600;
  font-size: 28px;
  line-height: 38px;
  color: #282938;
  margin-bottom: 12px;
}

.feature-desc {
  font-size: 18px;
  color: #666;
  line-height: 1.5;
  padding: 0 20px;
}

.story-section {
  padding: 100px 0;
  position: relative;
}

.story-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.story-main {
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 80px;
  display: flex;
  align-items: center;
  gap: 100px;
  position: relative;
  z-index: 1;
}

.story-img-placeholder {
  width: 500px;
  height: 500px;
  background: #f0f0f0;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #bbb;
  flex-shrink: 0;
}

.story-info {
  width: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}

.story-title {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-weight: 600;
  font-size: 48px;
  line-height: 64px;
  color: #282938;
  margin-bottom: 12px;
}

.story-desc {
  font-size: 18px;
  color: #666;
  line-height: 1.8;
  padding-right: 20px;
}

.aegis-section {
  padding: 100px 0;
  position: relative;
}

.aegis-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.aegis-banner {
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 80px;
  display: flex;
  align-items: center;
  gap: 100px;
  position: relative;
  z-index: 1;
}

.aegis-img-placeholder {
  width: 500px;
  height: 500px;
  background: #f0f0f0;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #bbb;
  flex-shrink: 0;
}

.aegis-info {
  width: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}

.aegis-title {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-weight: 600;
  font-size: 48px;
  line-height: 64px;
  color: #282938;
  margin-bottom: 12px;
}

.aegis-desc {
  font-size: 18px;
  color: #666;
  line-height: 1.8;
  padding-right: 20px;
}

.aegis-history {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.aegis-history-item {
  font-size: 18px;
  color: #666;
  line-height: 1.5;
}

.testimonials-section {
  padding: 100px 0;
  position: relative;
}

.testimonials-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.testimonials-list {
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 80px;
  display: flex;
  justify-content: space-around;
  gap: 32px;
  flex-wrap: wrap;
}

.testimonial-card {
  width: 300px;
  height: 200px;
  background: #fff;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
  cursor: pointer;
  overflow: hidden;
}

.testimonial-card:hover {
  transform: translateY(-10px);
}

.testimonial-img-placeholder {
  width: 100px;
  height: 100px;
  background: #f0f0f0;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #bbb;
  margin-bottom: 15px;
}

.testimonial-content {
  font-size: 18px;
  color: #666;
  line-height: 1.8;
  padding: 0 20px;
}

.faq-section {
  padding: 100px 0;
  position: relative;
}

.faq-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.faq-title {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-weight: 600;
  font-size: 48px;
  line-height: 64px;
  color: #282938;
  text-align: center;
  margin-bottom: 60px;
  padding: 0 80px;
}

.faq-title span {
  color: #ffd24d;
  font-size: 24px;
  margin-left: 8px;
}

.el-collapse {
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 80px;
}

.el-collapse-item__header {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-weight: 600;
  font-size: 28px;
  line-height: 38px;
  color: #282938;
  background-color: #f7f7f7;
  border-radius: 10px;
  padding: 15px 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.el-collapse-item__header:hover {
  background-color: #e0e0e0;
}

.el-collapse-item__content {
  padding: 0 20px 20px 20px;
  font-size: 18px;
  color: #666;
  line-height: 1.8;
}

.custom-contact-form {
  width: 691px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: none;
  box-shadow: none;
  padding: 0;
}

.custom-contact-form .el-form-item {
  margin-bottom: 32px;
}

.custom-contact-form .el-input,
.custom-contact-form .el-textarea {
  width: 691px;
  background: none;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 40px;
  color: #fff;
  font-size: 20px;
  padding: 18px 32px;
}

.custom-contact-form .el-input {
  height: 75px;
}

.custom-contact-form .el-textarea {
  height: 187px;
  min-height: 187px !important;
  max-height: 187px !important;
  border-radius: 40px;
  resize: none;
}

::v-deep .custom-contact-form .el-input__inner,
::v-deep .custom-contact-form .el-textarea__inner,
::v-deep .custom-contact-form input,
::v-deep .custom-contact-form textarea {
  background: none !important;
  color: #fff !important;
  font-size: 20px;
  box-shadow: none !important;
  border: none !important;
}

.custom-contact-form .el-input::placeholder,
.custom-contact-form .el-textarea::placeholder {
  color: #fff;
  opacity: 0.7;
}

.custom-contact-form .el-input.is-focus,
.custom-contact-form .el-textarea.is-focus {
  border-color: #ffd24d;
}

.contact-submit-btn {
  width: 100%;
  height: 64px;
  border-radius: 40px;
  background: #ffe08a;
  color: #282938;
  font-size: 22px;
  font-weight: 600;
  border: none;
  box-shadow: none;
  transition: background 0.2s;
}

.contact-submit-btn:hover {
  background: #ffe066;
}

.footer-nav {
  width: 100%;
  color: #fff;
  padding: 20px 0;
  text-align: center;
  font-size: 14px;
  position: relative;
  z-index: 100;
}

.footer-nav::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.footer-nav-content {
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-nav-logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.footer-nav-logo img {
  width: 100px;
  height: 40px;
}

.footer-nav-links {
  display: flex;
  gap: 40px;
}

.footer-nav-links a {
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s ease;
}

.footer-nav-links a:hover {
  color: #ffd24d;
}

.footer-nav-copyright {
  font-size: 14px;
  color: #282938;
}

.guardian-bg-table-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 24px;
  position: relative;
}

.guardian-bg-table {
  width: 100%;
  // max-width: 1440px;
  background: #fff;
  margin: 70px auto 0 auto;
}

.guardian-bg-row {
  display: flex;
  align-items: center;
  width: 100%;
  height: 99.63px;
  justify-content: space-between;
  transition: all 0.3s ease;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  position: relative;
}

.guardian-bg-row:hover::after {
  opacity: 1;
}

/* 悬停时整行样式 */
.row-hovered {
  background-color: rgba(229, 174, 33, 0.05);

  &::after {
    opacity: 1;
  }

  .guardian-bg-col {
    color: #e5ae21 !important;
    opacity: 1 !important;
  }
}

.guardian-bg-col {
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
}

.guardian-bg-col.year {
  width: 15%;
  min-width: 180px;
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-weight: 500;
  font-size: 36px;
  line-height: 56px;
  color: #282938;
  flex-shrink: 0;
  justify-content: flex-start;
  padding-left: 0;
}

.guardian-bg-col.event {
  width: 60%;
  min-width: 400px;
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-weight: 500;
  font-size: 36px;
  line-height: 56px;
  color: #282938;
  justify-content: center;
  text-align: center;
  flex-shrink: 0;
  position: relative;
}

.event-text {
  display: inline-block;
  padding: 0 10px;
  border-radius: 4px;
  cursor: pointer;
  transition: color 0.3s ease;
  position: relative;
}

.guardian-bg-col.desc {
  flex: 1;
  width: 25%;
  min-width: 200px;
  height: 56px;
  opacity: 0.5;
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  color: #666;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  padding-left: 60px;
  padding-right: 40px;
  align-items: flex-start;
}

.parent-faq-section {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin-top: 100px;
  padding: 0 80px;
}

.parent-faq-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.parent-faq-left {
  width: 328px;
  min-width: 328px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
}

.parent-faq-subtitle {
  font-weight: 500;
  font-size: 18px;
  color: #282938;
  margin-bottom: 8px;
}

.parent-faq-title {
  font-weight: 600;
  font-size: 38px;
  color: #282938;
  position: relative;
  margin-bottom: 16px;
}

.parent-faq-underline {
  position: absolute;
  left: 0px;
  top: 90px;
  width: 160px;
  height: 18px;
  border-radius: 10px;
  z-index: 0;
  pointer-events: none;
  user-select: none;
}

.parent-faq-btn {
  width: 120px;
  height: 40px;
  border-radius: 100px;
  border: 1px solid #282938;
  background: #fff;
  color: #282938;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.parent-faq-btn:hover {
  background: #ffe066;
}

.parent-faq-right {
  width: 846.31px;
  min-width: 846.31px;
  height: 832px;
  border-radius: 32px;
  padding: 48px 40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.parent-faq-list {
  width: 100%;
}

.parent-faq-item {
  border-bottom: 1px solid #eee;
  padding: 0 0 16px 0;
  margin-bottom: 16px;
}

.parent-faq-qrow {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.parent-faq-number {
  font-weight: 500;
  font-size: 24px;
  color: #e5ae21;
  margin-right: 16px;
  flex-shrink: 0;
}

.parent-faq-question {
  font-weight: 500;
  font-size: 24px;
  color: #282938;
  flex: 1;
}

.parent-faq-toggle {
  font-size: 32px;
  color: #bbb;
  margin-left: 16px;
  font-weight: 500;
}

.parent-faq-answer {
  font-weight: 500;
  font-size: 18px;
  color: #282938;
  opacity: 0.5;
  margin-top: 8px;
  line-height: 1.5;
  margin-left: 40px;
}

.parent-faq-title-img {
  width: 328px;
  height: auto;
  display: block;
  margin-bottom: 32px;
}

.practice-section {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
  background: none;
  position: relative;
  min-height: 650px;
  padding: 0 80px;

  // 英文版本增加最小高度
  .lang-en & {
    min-height: 650px;
  }
}

.practice-section-inner {
  width: 100%;
  height: 650px;
  background: #267E75;
  border-radius: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  padding: 0 0 0 80px;
  position: relative;

  // 英文版本增加高度
  .lang-en & {
    height: 650px;
  }
}

.practice-section-left {
  width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-right: 80px;
  overflow: hidden;
}

.practice-section-title {
  font-family: "Alibaba PuHuiTi";
  font-weight: 600;
  font-size: 54px;
  line-height: 74px;
  color: #fff;
  margin-bottom: 48px;
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;

  // 英文版本字体大小调整
  .lang-en & {
    font-size: 42px;
    line-height: 56px;
  }
}

.practice-section-desc {
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  color: #fff;
  text-align: left;
  margin-bottom: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;

  // 英文版本字体大小调整
  .lang-en & {
    font-size: 14px;
    line-height: 24px;
  }
}

.practice-section-check {
  color: #fff;
  font-size: 18px;
  margin-right: 8px;
  font-weight: 600;
}

.practice-section-desc-sub {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  margin-top: 8px;
}

.practice-section-right {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  margin-top: 120px;
}

.qr-contact-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  border-radius: 24px;
}

.qr-img {
  width: 243px;
  height: 243px;
  margin-bottom: 20px;
  border-radius: 10px;
  object-fit: cover;
}

.qr-tip {
  font-size: 16px;
  margin-bottom: 20px;
  text-align: center;
  color: #282938;
}

.contact-info-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  margin-top: 32px;
}

.contact-info-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 180px;
}

.contact-info-label {
  font-size: 18px;
  color: #282938;
  font-weight: 600;
  margin-bottom: 8px;
}

.contact-info-value {
  font-size: 16px;
  color: #282938;
  font-weight: 400;
}

.blog-section {
  background: #fff;
  margin: 0 auto;
  margin-bottom: 80px;
  margin-top: 80px;
  padding: 0 80px;
}

.blog-header {
  width: 1440px;
  margin-bottom: 40px;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 32px;
  // /* 与表单左对齐 */
  // max-width: 1440px;
  // margin: 0 auto 32px auto;
  // padding-left: 80px;
}

.blog-title {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-weight: 600;
  font-size: 48px;
  color: #282938;
  letter-spacing: 0;
}

.blog-more-btn {
  font-size: 16px;
  color: #282938;
  border: 2px solid #282938;
  border-radius: 41px;
  padding: 0 24px;
  background: #fff;
  font-weight: 500;
  margin-left: 10px;
  height: 40px;
  line-height: 40px;
  min-width: 112px;
  width: auto;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.blog-list {
  width: 100%;
  display: flex;
  gap: 40px;
  justify-content: space-between;
  // max-width: 1280px;
  // margin: 0 auto;
}

.blog-card {
  width: 458px;
  height: 870px;
  border-radius: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.blog-img-box {
  width: 100%;
  height: 610px;

  border-radius: 40px;
  overflow: hidden;
}

.blog-img-box img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  display: block;
  border-radius: 40px;
}

.blog-date {
  font-size: 16px;
  color: #888;
  margin: 16px 0 0 24px;
}

.blog-title-text {
  height: 120px;
  font-size: 24px;
  color: #282938;
  font-weight: 500;
  width: 100%;
  margin: 12px 0 0 24px;
  line-height: 1.4;
  white-space: pre-line;
}

.blog-desc {
  font-size: 15px;
  color: #666;
  margin: 8px 0 0 24px;
  line-height: 1.6;
}

.blog-link {
  font-size: 16px;
  color: #282938;
  margin: 0 0 24px 24px;
  text-decoration: none;
  display: flex;
  align-items: center;
  font-weight: 500;
}

.blog-link span {
  display: inline-block;
  width: 24px;
  font-size: 16px;
  margin-left: 4px;
}

.customer-testimonials-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f9fbfd;
  position: relative;
  margin-top: 80px;
  padding: 0 80px;
  padding-bottom: 40px;
  height: 892px;
}

.customer-testimonials-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  border-radius: 24px;
  box-sizing: border-box;
  margin-top: 60px;
  gap: 60px;
}

.customer-testimonials-left {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  .customer-testimonials-underline {
    position: absolute;
    width: 160px;
    height: 17px;
    border-radius: 10px;
    z-index: 0;
    pointer-events: none;
    user-select: none;
  }

  .customer-testimonials-underline-zh {
    top: 75%;
    left: 0%;
  }

  .customer-testimonials-underline-en {
    top: 70%;
    left: 9%;
  }

  .testimonial-meta {
    display: flex;
    align-items: flex-start;
    margin-bottom: 100px;
    height: 60px;
    /* 设置固定高度 */

    .avatar {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      object-fit: cover;
      margin-right: 8px;
    }

    .meta-info {
      .meta-name {
        font-size: 18px;
        font-weight: 500;
        color: #282938;
        margin-bottom: 2px;
      }

      .meta-school {
        color: #282938;
        font-size: 15px;
      }
    }
  }

  .testimonial-quote {
    position: relative;
    margin-top: 16px;

    .yinhao {
      position: absolute;
      top: -48px;
      left: 0;
      width: 48px;
      height: 48px;
      object-fit: contain;
      z-index: 1;
      pointer-events: none;
    }

    i {
      font-size: 24px;
      color: #e5ae21;
      margin-bottom: 10px;
      display: block;
    }

    .testimonial-text {
      height: 355px;
      font-size: 24px;
      color: #282938;
      line-height: 36px;
      white-space: pre-line;
      overflow-y: auto;
      /* 允许垂直滚动 */
      position: relative;
      scrollbar-width: none;
      /* Firefox */
      -ms-overflow-style: none;

      /* IE and Edge */
      &::-webkit-scrollbar {
        display: none;
        /* Chrome, Safari, Opera */
      }
    }
  }
}

.customer-testimonials-title {
  font-size: 38px;
  font-weight: 700;
  color: #282938;
  margin-bottom: 18px;
}

.customer-testimonials-desc {
  font-size: 18px;
  font-weight: 500;
  color: #282938;
}

.customer-testimonials-right {
  height: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 40px;
}

.customer-testimonials-img {
  height: 100%;
  width: 892px;
  border-radius: 24px;
  object-fit: cover;
  display: block;
}

.qr-contact-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  border-radius: 24px;
}

.qr-img {
  width: 243px;
  height: 243px;
  margin-bottom: 20px;
  border-radius: 10px;
  object-fit: cover;
}

.qr-tip {
  font-size: 16px;
  margin-bottom: 20px;
  text-align: center;
  color: #fff;
  opacity: 0.5;
}

.contact-info-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 40px;
  width: 100%;
  margin-top: 32px;
}

.contact-info-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 140px;
}

.contact-info-label {
  font-size: 18px;
  color: #fff;
  font-weight: 600;
  margin-bottom: 8px;
}

.contact-info-value {
  font-size: 16px;
  color: #fff;
  font-weight: 400;
  opacity: 0.8;
}

.partners-section {
  width: 100%;
  background: #267e75;
  border-radius: 0 0 24px 24px;
  padding: 40px 0 0 0;
  box-sizing: border-box;
  overflow-x: hidden;
}

.partners-content {
  margin: 0 auto;
  padding: 0 0px;
}

.partners-title-row {
  margin-bottom: 24px;
}

.partners-title {
  color: #fff;
  font-size: 32px;
  font-weight: 700;

  span {
    font-size: 18px;
    margin-left: 12px;
    color: #ffd24d;
  }
}

.partners-logos-row {
  overflow: hidden;
  width: 100%;
  margin-bottom: 32px;
  position: relative;
}

.logos-slider {
  display: flex;
  align-items: center;
  width: max-content;
}

.slide-left {
  animation: slideLeft 60s linear infinite;
}

.slide-right {
  animation: slideRight 60s linear infinite;
}

@keyframes slideLeft {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

@keyframes slideRight {
  0% {
    transform: translateX(-50%);
  }

  100% {
    transform: translateX(0);
  }
}

.testimonial-bottom-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 32px 0 0 0;
}

.testimonial-desc {
  color: #282938;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 16px;
}

.testimonial-learn-btn {
  border: 1.5px solid #282938;
  color: #282938;
  background: transparent;
  border-radius: 40px;
  height: 40px;
  line-height: 35px;
  padding: 0px 32px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.testimonial-learn-btn:hover {
  background: #282938;
  color: #fff;
}

.guardian-hover-img {
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  width: 616px;
  height: 382px;
  object-fit: cover;
  border-radius: 16px;
  z-index: 99;
  pointer-events: none;
  background: transparent;
}

.guardian-hover-img-container {
  position: fixed;
  /* 使用fixed定位，跟随鼠标 */
  width: 400px;
  /* 恢复原始宽度 */
  height: 250px;
  /* 恢复原始高度 */
  z-index: 99;
  pointer-events: none;
  transform: translate(20px, -50%);
  /* 将图片定位到鼠标右侧 */
  transition: none;
  /* 移除过渡效果，实现即时跟随 */
  border-radius: 16px;
  overflow: visible;
  /* 修改为visible，防止图片被裁剪 */
}

.guardian-hover-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  /* 修改为contain，确保图片完整显示 */
  border-radius: 16px;
  // box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.guardian-hover-text-container {
  position: fixed;
  /* 使用fixed定位，跟随鼠标 */
  width: 300px;
  /* 文字容器宽度 */
  z-index: 99;
  pointer-events: none;
  transform: translate(20px, -50%);
  /* 将文字框定位到鼠标右侧 */
  transition: none;
  /* 移除过渡效果，实现即时跟随 */
}

.guardian-hover-text {
  background: #fff;
  /* 深色半透明背景 */
  color: #282938;
  padding: 16px 20px;
  border-radius: 12px;
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  /* 添加阴影效果 */
  backdrop-filter: blur(10px);
  /* 背景模糊效果 */
  -webkit-backdrop-filter: blur(10px);
  /* Safari兼容 */
  border: 1px solid rgba(255, 255, 255, 0.1);
  /* 添加细边框 */
  word-wrap: break-word;
  /* 文字换行 */
  white-space: normal;
  /* 允许换行 */
}

.school-feedback-section {
  width: 100%;
  height: 799px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  position: relative;
  margin-top: 80px;
  padding: 0 80px;
}

.school-feedback-container {
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.school-feedback-title-box {
  position: relative;
  width: 100%;
  max-width: 1440px;
  text-align: left;
}

.school-feedback-header {
  position: absolute;
  top: 80px;
  left: 80px;
  z-index: 10;
}

.school-feedback-title {
  font-size: 18px;
  font-weight: 500;
  color: #282938;
  margin-bottom: 8px;
}

.school-feedback-title-underline {
  position: absolute;
  left: 0;
  bottom: -19px;
  width: 159.97px;
  height: 17.72px;
  border-radius: 10px;
  z-index: 0;
  pointer-events: none;
  user-select: none;
}

.school-feedback-subtitle {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #282938;
  margin-bottom: 8px;
}

.school-feedback-main-title {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-size: 48px;
  font-weight: 600;
  color: #282938;
  margin-bottom: 24px;
  position: relative;
  line-height: 1.2;
}

.school-feedback-underline {
  width: 120px;
  height: 17.72px;
  border-radius: 10px;
  pointer-events: none;
  user-select: none;
  margin-top: 8px;
}

.school-feedback-carousel {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.carousel-container {
  // position: relative;
  width: 900px;
  height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-slide {
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.carousel-slide.active {
  opacity: 1;
}

.feedback-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 700px;
}

.school-icon {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.school-icon img {
  object-fit: contain;
}

.school-icon img[src*="schoolicon1"] {
  width: 81px;
  height: 100px;
}

.school-icon img[src*="schoolicon2"] {
  width: 88px;
  height: 114px;
}

.school-icon img[src*="schoolicon3"] {
  width: 464px;
  height: 80px;
}

.feedback-author {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 32px;
}

.author-name {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #282938;
  margin-bottom: 8px;
}

.author-title {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  line-height: 1.5;
  white-space: pre-line;
}

.feedback-quote {
  display: flex;
  position: relative;
  border-radius: 20px;
  padding: 40px;
  margin-top: 16px;
  justify-content: center;
  // max-width: 1000px;
  // min-width: 716px;
  gap: 24px;
  background: #f9fbfd;
  width: 1120px;
}

.quote-marks {
  position: absolute;
  top: -20px;
  left: 20px;
  font-size: 48px;
  color: #ffd24d;
  font-weight: 700;
}

.quote-mark-right {
  width: 48px;
  height: 26px;
  object-fit: contain;
}

.quote-mark-left {
  width: 48px;
  height: 26px;
  object-fit: contain;
}

.quote-text {
  font-family: "Alibaba PuHuiTi", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
  font-size: 16px;
  color: #282938;
  line-height: 28px;
  text-align: center;
  font-weight: 400;
  width: fit-content;
}

.quote-text-line {
  width: fit-content;
  margin: 0 auto;
  white-space: nowrap;
  overflow: visible;
}

.carousel-indicators {
  position: absolute;
  bottom: 135px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  z-index: 3;
}

.indicator {
  width: 8px;
  height: 8px;
  background: #fff;
  border: 1px solid #282938;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.indicator.active {
  width: 20px;
  height: 8px;
  border-radius: 100px;
  background-color: #282938;
}
</style>
